import React, { useState } from 'react';
import './TopRecruiters.css';

const CATEGORIES = [
  { id: 'tech', label: 'Technology' },
  { id: 'finance', label: 'Finance & Banking' },
  { id: 'consulting', label: 'Consulting & Analytics' },
];

const RECRUITERS = {
  tech: [
    { name: 'Amazon',     color: '#FF9900' },
    { name: 'Google',     color: '#4285F4' },
    { name: 'Microsoft',  color: '#00A4EF' },
    { name: 'Infosys',    color: '#007CC3' },
    { name: 'TCS',        color: '#E0201D' },
    { name: 'Wipro',      color: '#341C6E' },
    { name: 'Cognizant',  color: '#1263AB' },
    { name: 'HCL',        color: '#0A74DA' },
    { name: 'IBM',        color: '#1F70C1' },
    { name: 'Adobe',      color: '#FF0000' },
    { name: 'Oracle',     color: '#C74634' },
    { name: 'Flipkart',   color: '#2874F0' },
    { name: 'Walmart',    color: '#0071CE' },
    { name: 'Myntra',     color: '#FF3F6C' },
    { name: 'Salesforce', color: '#00A1E0' },
  ],
  finance: [
    { name: 'HDFC Bank',       color: '#004C8F' },
    { name: 'ICICI Bank',      color: '#F47920' },
    { name: 'SBI',             color: '#2D6DB4' },
    { name: 'Axis Bank',       color: '#800000' },
    { name: 'Kotak',           color: '#ED1C24' },
    { name: 'Yes Bank',        color: '#00539B' },
    { name: 'Goldman Sachs',   color: '#1C3F5E' },
    { name: 'Morgan Stanley',  color: '#003B6F' },
    { name: 'JP Morgan',       color: '#003087' },
    { name: 'Citi',            color: '#003B70' },
    { name: 'EY',              color: '#FFE600' },
    { name: 'Deloitte',        color: '#86BC25' },
    { name: 'KPMG',            color: '#00338D' },
    { name: 'Edelweiss',       color: '#00B0CA' },
    { name: 'IndusInd Bank',   color: '#E31837' },
  ],
  consulting: [
    { name: 'McKinsey',    color: '#003580' },
    { name: 'BCG',         color: '#00843D' },
    { name: 'Bain & Co',   color: '#CC0000' },
    { name: 'PwC',         color: '#E0301E' },
    { name: 'Accenture',   color: '#A100FF' },
    { name: 'Capgemini',   color: '#003179' },
    { name: 'Genpact',     color: '#00ADEF' },
    { name: 'EXL',         color: '#0047BA' },
    { name: 'WNS',         color: '#004B8D' },
    { name: 'Fractal',     color: '#FF6B00' },
    { name: 'Mu Sigma',    color: '#E4002B' },
    { name: 'Deloitte',    color: '#86BC25' },
    { name: 'KPMG',        color: '#00338D' },
    { name: 'ZS Associates', color: '#006341' },
    { name: 'Aon',         color: '#CC0000' },
  ],
};

const MarqueeRow = ({ items, reverse }) => {
  // Duplicate for seamless loop
  const doubled = [...items, ...items];
  return (
    <div className={`tr-marquee-row ${reverse ? 'tr-marquee-row--reverse' : ''}`}>
      <div className={`tr-marquee-track ${reverse ? 'tr-marquee-track--reverse' : ''}`}>
        {doubled.map((company, i) => (
          <div className="tr-chip" key={i}>
            <span className="tr-chip-dot" style={{ background: company.color }} />
            <span className="tr-chip-name">{company.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const TopRecruiters = () => {
  const [active, setActive] = useState('tech');
  const companies = RECRUITERS[active];
  const mid = Math.ceil(companies.length / 2);
  const row1 = companies.slice(0, mid);
  const row2 = companies.slice(mid);

  return (
    <section id="recruiters" className="tr-section section">
      {/* Header */}
      <div className="tr-header">
        <p className="tr-label">Top Recruiters</p>
        <h2 className="tr-heading">
          Step into opportunities with&nbsp;
          <span className="tr-heading-accent">leading organizations</span>
        </h2>
        <p className="tr-sub">that match your talent and aspirations</p>
      </div>

      {/* Tabs */}
      <div className="tr-tabs">
        {CATEGORIES.map(cat => (
          <button
            key={cat.id}
            className={`tr-tab ${active === cat.id ? 'tr-tab--active' : ''}`}
            onClick={() => setActive(cat.id)}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Marquee rows */}
      <div className="tr-marquee-wrap">
        <div className="tr-fade-left" />
        <div className="tr-fade-right" />
        <MarqueeRow items={row1} reverse={false} />
        <MarqueeRow items={row2} reverse={true} />
      </div>
    </section>
  );
};

export default TopRecruiters;
